var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mb-3",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.payload.content))}}),_c('a',{staticClass:"button is-outlined is-info",on:{"click":_vm.openInternalNotes}},[_vm._v("Create new resource")])])
}
var staticRenderFns = []

export { render, staticRenderFns }